<template>
  <section
    :class="{
      'section-builder-review-cards': true,
    }"
  >
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'fluid-container mx-auto': true,
        }"
      >
        <PortableText
          v-if="heading?.standardPortableText"
          :portable-data="heading?.standardPortableText"
          :class="{
            'mb-7': true,
          }"
        />
        <div
          :class="{
            'grid grid-cols-12 gap-x-8 gap-y-4': true,
          }"
        >
          <div
            v-for="(card, index) in cards"
            :key="index"
            :class="{
              'review-card col-span-12 md:col-span-6 lg:col-span-4': true,
            }"
          >
            <ReviewCard v-bind="card" />
          </div>
        </div>
      </div>
    </GeneralTheme>
  </section>
</template>

<script setup lang="ts">
import type { SectionBuilderReviewCards } from '~/sanity/types';
import GeneralTheme from '../Themes/GeneralTheme.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import ReviewCard from './ReviewCard.vue';

defineProps<SectionBuilderReviewCards>();
</script>

<style scoped></style>
